import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Renter } from "@/api/renters";
import { getIdFromUserHandbook } from "@/utils/getIdFromHandbooks.ts";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";

interface IEditLockForm {
  display_name: string;
  orgn: string;
  holder: number;
  phone_number: string;
  email: string;
}

const editLockFields: InputField[] = [
  {
    label: "Название компании",
    name: "display_name",
    placeholder: "ОАО 'МММ)'",
    type: "text",
    isRequired: true,
  },
  {
    label: "ОРГН",
    name: "orgn",
    placeholder: "123...",
    type: "text",
    isRequired: true,
  },
  {
    label: "Владелец",
    name: "holder",
    placeholder: "",
    type: "user",
    isRequired: true,
  },
  {
    label: "Номер телефона",
    name: "phone_number",
    placeholder: "+7955...",
    type: "text",
    isRequired: true,
  },
  {
    label: "Адрес почты",
    name: "email",
    placeholder: "example@mail.ru",
    type: "text",
    isRequired: true,
  },
];

export function EditRenterModal({
  disclosure,
  renter,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  renter: Renter | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const navigate = useNavigate();
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: IEditLockForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      const holder = await getIdFromUserHandbook(String(data.holder));

      api.renters
        .update(renter!.id, {
          display_name: data.display_name,
          email: data.email,
          holder: Number(holder),
          orgn: data.orgn,
          phone_number: data.phone_number,
        })
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.renters
        .delete(renter!.id)
        .then((_data) => {
          disclosure.onClose();
          navigate("/dashboard/renters/");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование арендатора"
      fields={editLockFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        display_name: renter?.display_name,
        email: renter?.email,
        holder: renter?.holder,
        orgn: renter?.orgn,
        phone_number: renter?.phone_number,
      }}
    />
  );
}
